<template>
	<DialogControl v-model="open" max-width="600">
		<v-card rounded="xl" class="nav-dialog">
			<v-card-title class="nav-dialog__title">
				<v-icon color="primary">release_alert</v-icon>
				<span>{{ t('ReleaseNote') }}</span>
				<v-spacer />
				<v-btn icon variant="text" size="small" @click="open = false">
					<v-icon>close</v-icon>
				</v-btn>
			</v-card-title>
			<v-card-text>
				<v-list v-if="notes.length" bg-color="transparent">
					<v-list-item v-for="note in notes" :key="note.key" :link="Boolean(note.link)" class="nav-dialog__note" @click="note.link && openHelp(note.link)">
						<template #prepend>
							<v-avatar color="primary" variant="tonal" size="36">
								<v-icon size="20">{{ note.icon || 'new_releases' }}</v-icon>
							</v-avatar>
						</template>
						<v-list-item-title class="nav-dialog__note-title">{{ note.title }}</v-list-item-title>
						<div class="nav-dialog__text">{{ note.description }}</div>
					</v-list-item>
				</v-list>
				<p v-else class="nav-dialog__text">{{ t('NoData') }}</p>
			</v-card-text>
			<v-card-actions>
				<v-spacer />
				<v-btn variant="text" @click="open = false">{{ t('Close') }}</v-btn>
				<v-btn color="primary" variant="flat" prepend-icon="open_in_new" @click="openAllReleaseNotes">{{ t('AllReleaseNotes') }}</v-btn>
			</v-card-actions>
		</v-card>
	</DialogControl>
</template>

<script setup>
import { ref, watch } from 'vue';
import DialogControl from '@/components/controls/DialogControl.vue';
import { openAllReleaseNotes, openHelp, readReleaseNotes } from '@/iframe/legacyNavActions';
import { useTranslator } from '@/composables/useTranslator';

const open = defineModel({ type: Boolean, default: false });
const t = useTranslator();

const notes = ref([]);

watch(open, async (value) => {
	if (value) notes.value = await readReleaseNotes();
});
</script>
